import React from 'react';
import PropTypes from 'prop-types';
import { useUrlBuilder } from '../../hooks/useUrlBuilder';

import VerticalSpacer from '../../components_common/VerticalSpacer/VerticalSpacer';
import Wrapper from '../../components_common/Wrapper/Wrapper';
import BrowseDepartmentPair from './BrowseDepartmentPair';
import BrowseFooter from './BrowseFooter';
import { menUrlNewInSale, womenUrlNewInSale, kidsUrlNewInSale } from '../../helpers/routes';

const BrowseTiles = ({ children }) => {
  const { localized } = useUrlBuilder();
  return (
    <>
      <VerticalSpacer height="40px" />
      <Wrapper margin="0 35px 0 35px">{children}</Wrapper>
      <VerticalSpacer height="20px" />
      <Wrapper margin="0 5px 0 5px">
        <BrowseDepartmentPair
          department="women"
          leftUrl={localized(womenUrlNewInSale())}
          rightUrl={localized(womenUrlNewInSale(true))}
        />
        <VerticalSpacer height="20px" />
        <BrowseDepartmentPair
          department="men"
          leftUrl={localized(menUrlNewInSale())}
          rightUrl={localized(menUrlNewInSale(true))}
        />
        <VerticalSpacer height="20px" />
        <BrowseDepartmentPair
          department="kids"
          leftUrl={localized(kidsUrlNewInSale())}
          rightUrl={localized(kidsUrlNewInSale(true))}
        />
      </Wrapper>
      <VerticalSpacer height="33px" />
      <BrowseFooter />
      <VerticalSpacer height="40px" />
    </>
  );
};

BrowseTiles.propTypes = {
  isDesktop: PropTypes.bool,
};

export default BrowseTiles;
